import { z } from 'zod';
/**
 * Shared Zod schemas — the boundary definitions every package parses external
 * data against (docs/AGENTS.md §5: "Zod is the boundary").
 */
/**
 * A raw offer exactly as a connector/importer found it — raw strings only,
 * normalisation happens once in core (docs/06-SOURCES-CONNECTORS.md §1).
 */
export const rawOfferSchema = z.object({
    sourceKey: z.string().min(1),
    externalRef: z.string().min(1),
    gtinRaw: z.string().nullable(),
    referenceRaw: z.string().nullable(),
    nameRaw: z.string().min(1),
    brandRaw: z.string().nullable(),
    priceTtcRaw: z.string().nullable(),
    priceHtRaw: z.string().nullable(),
    vatRaw: z.string().nullable(),
    url: z.string().url().nullable(),
    inStock: z.boolean().nullable(),
});
/** A resolved match candidate as consumed by the review console (docs/09 §2). */
export const candidateDtoSchema = z.object({
    candidateId: z.number().int(),
    offerId: z.number().int(),
    sourceKey: z.string(),
    gtinRaw: z.string().nullable(),
    observedName: z.string(),
    observedBrand: z.string().nullable(),
    scoreTotal: z.number().min(0).max(1),
    band: z.enum(['auto', 'review', 'none']),
    corroborations: z.number().int().min(0),
    url: z.string().url().nullable(),
});
/** The KPI payload served by `GET /api/v1/kpis` (docs/00-PLAN.md §6). */
export const kpisDtoSchema = z.object({
    productsTotal: z.number().int(),
    publishedVisible: z.number().int(),
    sellableSkus: z.number().int(),
    gtinApproved: z.number().int(),
    gtinCoverage: z.number().min(0).max(1),
    openConflicts: z.number().int(),
    pendingReviews: z.number().int(),
    purchasePriceCoverage: z.number().min(0).max(1),
    /** share of sellable SKUs whose TVA comes from a supplier file (not the 19% default) */
    vatFileCoverage: z.number().min(0).max(1),
    /** sellable SKUs whose site barcode now equals the approved GTIN (corrections done) */
    siteAlignedGtin: z.number().int(),
    /** approved GTINs whose site barcode still differs — the « À corriger (Woo) » backlog */
    pendingSiteCorrections: z.number().int(),
    /** site products without a SKU, from the last Woo mirror run (INV-01) */
    siteMissingSku: z.number().int().nullable(),
    /** last Woo mirror completion (ISO) — the missing-SKU count is only as fresh */
    mirrorLastRunAt: z.string().nullable(),
    /** products deleted or soft-offlined / trashed from WooCommerce */
    deletedProductsCount: z.number().int().optional().default(0),
    /** products hidden from WooCommerce catalog or set to operator hide */
    hiddenProductsCount: z.number().int().optional().default(0),
    /** products currently marked out of stock */
    outOfStockCount: z.number().int().optional().default(0),
    /** product variations count */
    variationsCount: z.number().int().optional().default(0),
});
//# sourceMappingURL=schemas.js.map